<template>
  <div class="form_ct_box">
    <div class="flex ct_box">
      <div class="ct_left_box_2">
        <div class="flex" style="margin-bottom: 20px; align-items: center;">

          <p class="title_p">红人姓名：</p>
          <el-input v-model="form.title" placeholder="请输入红人姓名"></el-input>
        </div>
        <div class="flex" style="align-items: center;margin-bottom: 20px;">
          <upLoadImg title="红人头像" :limit="1" :case_url="form.heads" @get_img="get_img" />
        </div>
        <div class="flex" style="margin-bottom: 20px;">
          <p class="title_p">详情描述：</p>
          <vue-ueditor-wrap id="tinymce" v-model="form.content" :config="my_config"></vue-ueditor-wrap>
        </div>
      </div>
      <div class="ct_right_box_2">

        <specialText text="商务类型与报价" style="margin-bottom: 20px" />

        <ul class="horizontal-list">
          <li>
            <el-checkbox v-model="category.category_1" style="font-weight: 700; color: black;">品牌代言:</el-checkbox>
            <el-input v-model="form.price_1" :disabled="!category.category_1" placeholder="请输入价格"
              style="width: 120px; height: 33px; margin-right: 14px; margin-left: 5px;"></el-input>
            元/次
          </li>
          <li>
            <el-checkbox v-model="category.category_2" style="font-weight: 700; color: black;">祝福视频:</el-checkbox>
            <el-input v-model="form.price_2" :disabled="!category.category_2" placeholder="请输入价格"
              style="width: 120px; height: 33px; margin-right: 14px; margin-left: 5px;"></el-input>
            元/次
          </li>
        </ul>
        <ul class="horizontal-list">
          <li>
            <el-checkbox v-model="category.category_3" style="font-weight: 700; color: black;">主持司仪:</el-checkbox>
            <el-input v-model="form.price_3" :disabled="!category.category_3" placeholder="请输入价格"
              style="width: 120px; height: 33px; margin-right: 14px; margin-left: 5px;"></el-input>
            元/次
          </li>
          <li>
            <el-checkbox v-model="category.category_4" style="font-weight: 700; color: black;">微电影:</el-checkbox>
            <el-input v-model="form.price_4" :disabled="!category.category_4" placeholder="请输入价格"
              style="width: 120px; height: 33px; margin-left: 18px; margin-right: 14px;"></el-input>
            元/次
          </li>
        </ul>
        <ul class="horizontal-list">
          <li>
            <el-checkbox v-model="category.category_5" style="font-weight: 700; color: black;">广告:</el-checkbox>
            <el-input v-model="form.price_5" :disabled="!category.category_5" placeholder="请输入价格"
              style="width: 120px; height: 33px;  margin-left: 33px; margin-right: 14px;"></el-input>
            元/次
          </li>
          <li>
            <el-checkbox v-model="category.category_6" style="font-weight: 700; color: black;">商演:</el-checkbox>
            <el-input v-model="form.price_6" :disabled="!category.category_6" placeholder="请输入价格"
              style="width: 120px; height: 33px;  margin-left: 33px; margin-right: 14px;"></el-input>
            元/次
          </li>
        </ul>
        <ul class="horizontal-list">
          <li>
            <el-checkbox v-model="category.category_7" style="font-weight: 700; color: black;">翻包:</el-checkbox>
            <el-input v-model="form.price_7" :disabled="!category.category_7" placeholder="请输入价格"
              style="width: 120px; height: 33px;  margin-left: 33px; margin-right: 14px;"></el-input>
            元/次
          </li>
          <li>
            <el-checkbox v-model="category.category_8" style="font-weight: 700; color: black;">活动:</el-checkbox>
            <el-input v-model="form.price_8" :disabled="!category.category_8" placeholder="请输入价格"
              style="width: 120px; height: 33px;  margin-left: 33px; margin-right: 14px;"></el-input>
            元/次
          </li>
        </ul>
        <ul class="horizontal-list">
          <li>
            <el-checkbox v-model="category.category_9" style="font-weight: 700; color: black;">带货:</el-checkbox>
            <el-input v-model="form.price_9" :disabled="!category.category_9" placeholder="请输入价格"
              style="width: 120px; height: 33px;  margin-left: 33px; margin-right: 14px;"></el-input>
            元/次
          </li>
          <li>
            <el-checkbox v-model="category.category_10" style="font-weight: 700; color: black;">其他:</el-checkbox>
            <el-input v-model="form.price_10" :disabled="!category.category_10" placeholder="请输入价格"
              style="width: 120px; height: 33px;  margin-left: 33px; margin-right: 14px;"></el-input>
            元/次
          </li>
        </ul>


        <specialText text="特殊类目" style="margin-bottom: 20px" />

        <div class="flex" style="align-items: center;margin-bottom: 30px;">
          <p class="title_p5">标签：</p>
          <el-radio v-model="form.tags" :label="0">不限</el-radio>
          <el-radio v-model="form.tags" :label="1">推荐</el-radio>
          <el-radio v-model="form.tags" :label="2">热门</el-radio>
          <el-radio v-model="form.tags" :label="3">优惠</el-radio>
        </div>

        <div class="flex" style="align-items: center;margin-bottom: 30px;">
          <p class="title_p5">性别：</p>
          <el-radio v-model="form.age" :label="0">不限</el-radio>
          <el-radio v-model="form.age" :label="1">男性</el-radio>
          <el-radio v-model="form.age" :label="2">女性</el-radio>
        </div>

        <div class="flex" style="align-items: center;margin-bottom: 30px;">
          <p class="title_p5">职业：</p>
          <el-radio v-model="form.career" :label="0">不限</el-radio>
          <el-radio v-model="form.career" :label="1">演员</el-radio>
          <el-radio v-model="form.career" :label="2">歌手</el-radio>
          <el-radio v-model="form.career" :label="3">体育</el-radio>
          <el-radio v-model="form.career" :label="4">模特</el-radio>
          <el-radio v-model="form.career" :label="5">主持人</el-radio>
          <el-radio v-model="form.career" :label="6">网红</el-radio>
          <el-radio v-model="form.career" :label="7">其他</el-radio>
        </div>

        <div class="flex" style="align-items: center;margin-bottom: 30px;">
          <p class="title_p5">地域：</p>
          <el-radio v-model="form.area" :label="0">不限</el-radio>
          <el-radio v-model="form.area" :label="1">大陆</el-radio>
          <el-radio v-model="form.area" :label="2">香港</el-radio>
          <el-radio v-model="form.area" :label="3">澳门</el-radio>
          <el-radio v-model="form.area" :label="4">台湾</el-radio>
          <el-radio v-model="form.area" :label="5">日韩</el-radio>
          <el-radio v-model="form.area" :label="6">欧美</el-radio>
          <el-radio v-model="form.area" :label="7">其他</el-radio>
        </div>

        <div class="flex" style="align-items: center;margin-bottom: 30px;">
          <p class="title_p5">年代：</p>
          <el-radio v-model="form.years" :label="0">不限</el-radio>
          <el-radio v-model="form.years" :label="1">50后</el-radio>
          <el-radio v-model="form.years" :label="2">60后</el-radio>
          <el-radio v-model="form.years" :label="3">70后</el-radio>
          <el-radio v-model="form.years" :label="4">80后</el-radio>
          <el-radio v-model="form.years" :label="5">90后</el-radio>
          <el-radio v-model="form.years" :label="6">00后</el-radio>
          <el-radio v-model="form.years" :label="7">10后</el-radio>
        </div>

        <!-- <div>
        <p>Selected: {{ form.checkbox1 }}</p>
        <p>Selected: {{ this.form.someVariable }}</p>
        <p>Selected: {{ form.text1 }}</p> 
        </div> -->

        <!-- <talent_add_upload /> -->
      </div>
    </div>
    <div class="flex cofirm_box">
      <button class="cancel" @click="$router.push('/user/pub_talent/pubtalent')">
        取消
      </button>

      <button v-if="!$route.query.id" class="affirm" @click="addMedia">
        确认
      </button>
      <button v-else class="affirm" @click="updateFn">修改</button>
    </div>
  </div>
</template>

<script>
  import add_select from '@/components/add_select'
  import add_platform from '@/components/add_platform'
  import add_delivery from '@/components/add_delivery'
  import VueUeditorWrap from 'vue-ueditor-wrap'
  import config from '@/util/ueditor.config'
  import talent_add_upload from '@/components/talent_add_upload'

  export default {
    components: {
      add_select,
      add_platform,
      add_delivery,
      VueUeditorWrap,
      talent_add_upload
    },

    mounted() {
      this.get_data()
      if (this.$route.query.id) {
        this.get_update_data()
      }
    },
    watch: {
      // 监听 form.content 的变化
      'form.content': {
        handler(newValue, oldValue) {
          // console.log('/api')
          // this.form.content=this.addServerPrefixToImyearss(newValue,'http://login.qixuantong.vip')
          // console.log(this.form.content)
        },
        // 可以设置 immediate 为 true，让监听在组件创建时就触发一次
        immediate: true
      }
    },
    data() {
      return {
        // area_list: [],
        category: {
          category_1: false,
          category_2: false,
          category_3: false,
          category_4: false,
          category_5: false,
          category_6: false,
          category_7: false,
          category_8: false,
          category_9: false,
          category_10: false,
        },
        form: {
          category_id: '',
          title: '',
          heads: '',
          ercode: '',
          content: '',
          tags: 0,
          age: 0,
          years: 0,
          career: 0,
          area: 0,
          years: 0,
          price_1: '',
          price_2: '',
          price_3: '',
          price_4: '',
          price_5: '',
          price_6: '',
          price_7: '',
          price_8: '',
          price_9: '',
          price_10: '',
        },
        my_config: config,
        imageUrl: '',
        headers: {
          token: this.$user_info.token,
        },
      }
    },

    methods: {
      // addServerPrefixToImyearss(richText, serverPrefix) {
      //   const imgRegex = /<img[^>]+src="([^"]+)"/g;
      //   return richText.replace(imgRegex, (match, src) => {
      //     // 检查图片地址是否已经包含前缀
      //     if (!src.startsWith(serverPrefix)) {
      //       // 拼接服务器地址前缀
      //       const newSrc = serverPrefix + src;
      //       return match.replace(src, newSrc);
      //     }
      //     return match;
      //   });
      // },

      get_update_data() {
        let data = {
          id: this.$route.query.id
        }
        this.curlGet('/api/users/hongren/info/detail', data).then(res => {
          if (res.data.code) {
            for (const key in res.data.data) {
              this.form[key] = res.data.data[key]
              // 重新定义category_id
              this.form.category_id = '';
            }
            res.data.data.cat_id.forEach((item, index) => {
              var cat = "category_" + item
              this.category[cat] = true
            })
          }
        })
      },

      get_data() {
        this.curlGet('/api/hongren/info/init').then(res => {
          if (res.data.code) {
            let data = res.data.data[1];
            // this.area_list = data.area_list
          }
        })
      },
      // 添加媒体
      addMedia() {
        this.$confirm('确认提交吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          let cnum = 0;
          this.category = Object.values(this.category)
          this.category.forEach((item, index) => {
            if (item === true) {
              if (this.form.category_id != '') {
                this.form.category_id = this.form.category_id + ','
              }
              this.form.category_id = this.form.category_id + (index + 1).toString();
            } else {
              cnum++
            }
          })
          if (cnum == 10) {
            return this.$message({
              type: 'warning',
              message: '请选择商务类型并填写报价',
            })
          }
          this.curlPost('/api/users/hongren/info/save', this.form).then((res) => {
            if (res.data.code) {
              this.$message({
                type: 'success',
                message: res.data.msg,
              })
              return this.$router.push('/user/pub_talent/pubtalent')
            } else {
              return this.$message({
                type: 'warning',
                message: res.data.msg,
              })
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
      },


      // 修改媒体
      updateFn() {
        console.log(123);
        this.$confirm('确认修改吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          let data = this.form
          data.id = this.$route.query.id

          let cnum = 0;
          this.category = Object.values(this.category)
          this.category.forEach((item, index) => {
            if (item === true) {
              if (this.form.category_id != '') {
                this.form.category_id = this.form.category_id + ','
              }
              this.form.category_id = this.form.category_id + (index + 1).toString();
            } else {
              cnum++
            }
          })
          if (cnum == 10) {
            return this.$message({
              type: 'warning',
              message: '请选择商务类型并填写报价',
            })
          }
          console.log("data:", data);
          this.curlPost('/api/users/hongren/info/save', data).then((res) => {
            if (res.data.code) {
              this.$message({
                type: 'success',
                message: '已修改',
              })
              return this.$router.push('/user/pub_talent/pubtalent')
            } else {
              return this.$message({
                type: 'warning',
                message: res.data.msg,
              })
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
      },

      get_img(url) {
        console.log("url:", url);
        this.form.heads = url
      },
      // get_img1(url) {
      //   this.form.ercode = url
      // },

    },
  }
</script>



<style lang=scss scoped>
  @use '@/scss/AddResource';
</style>